<template>
  <section class="d-flex flex-column h-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      ref="top_app_bar"
      staticMode="true"
    ></TopAppBar>

    <div class="flex-grow-1 scroll-y">
      <PrizeRequestList></PrizeRequestList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
/**
 * 단독설문 메인 컴포넌트(independent survey main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import PrizeRequestList from "@/components/prizeRequest/List";
// import PrizeHistory from "@/components/prizeRequest/PrizeHistory";

export default {
  name: "PrizeRequest",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
    };
  },
  components: {
    TopAppBar,
    PrizeRequestList,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },

  mounted() {
    this.setTopAppBarHomeBlank(this.$t("1968"));
  },
};
</script>